module.exports = __webpack_public_path__ + "img/team-lueneburg@2x.4e321ee7.jpg";